import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useFeatureFlags } from '@/helper/FeatureFlags';
import { useFunctionalPermissions } from '@/helper/FunctionalPermissions';
import { useAppConfig } from '@/hooks/useAppConfig';
import useDefaultWidgetId from '@/modules/corporate/modules/discover/views/Discover/hooks/useDefaultWidgetId';

import { UnifiedNav } from '../../types';
import { buildUnifiedNav } from '../../utils';

function useUnifiedNav(): UnifiedNav {
  const { t } = useTranslation(['Common', 'Admin']);
  const flags = useFeatureFlags();
  const { site, ui } = useAppConfig();
  const { defaultWidgetId } = useDefaultWidgetId();
  const { hasPermission } = useFunctionalPermissions();

  const communityId = site.defaultCommunitySettings?.communityId;
  const isQuestionBankDisabled = !!ui?.disableQuestionBank;

  return useMemo(
    () =>
      buildUnifiedNav({
        t,
        flags,
        communityId,
        defaultWidgetId,
        isQuestionBankDisabled,
        hasPermission,
      }),
    [t, flags, communityId, defaultWidgetId, isQuestionBankDisabled, hasPermission],
  );
}

export default useUnifiedNav;
